export const getImage = (defaultImg: string, imageBase64?: string) => {
  return imageBase64 ? `data:image/png;base64,${imageBase64}` : defaultImg;
};

export const getBase64 = (img: any, callback: any) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
